import OnLoad from './on-load';

/**
 * handles onLoad lazy-load elements
 */
export default class ExitIntent extends OnLoad {

	afterInsert() {
		this.event = 'mouseout';
		this.eventHandler = ( event ) => this.onExitIntent( event );
		this.manageEvent();
	}

	onExitIntent( event ) {

		if ( null !== event.toElement || null !== event.relatedTarget ) {
			return;
		}
		this.manageEvent( false );
		const {
			exitIntentSelector,
			templateId,
			widgetId
		} = this.data;

		if( exitIntentSelector && document.querySelector( exitIntentSelector ) ){
			document.querySelector( exitIntentSelector ).style.display = 'block';
		}

		const eventData = {
			templateId,
			widgetId,
			element: this.element,
			trigger: this,
		};
		this.triggerEvent( 'show/after', eventData );
		this.triggerEvent( `show/after/${templateId}-${widgetId}`, eventData );
	}
}
